#import './automation-action-fragment.graphql'

fragment MarketingAutomationFragment on Automation {
    id
    type
    actions {
        ...AutomationActionFragment
    }
}
